/*
global color schema
*/

$main-color: #176BB3;
$OE-Blue:#0084FF;
$OELogo-blue:#2d6ab1;
$human-blue: #4FA3D9;
$news-blue: #0088ff;
$achievable-green: #A1C23B;
$fun-yellow: #FAD106;
$orange: #EFBD08;
$light-grey: #E8E8F0;
$bg-grey: #efeff2;
$lighter-grey: #f3f3f3;
$grey-e2: #e2e2e2;
$dark-grey: #828282;
$grey-120: #787878;
$black: #000;
$red: #F1000C;
$darker-gray: #464646;
$yellow-link: #edbc14;
$red-orange: #FF5F00;



// WEBPACK FOOTER //
// ./css/theme/lp20/_colors.scss